import _ from 'lodash';
import { FETCH_COMMENTS_REQUEST, FETCH_COMMENTS_SUCCESS } from '../actions/fetch-comments';
import { FETCH_COMMENT_SUCCESS } from '../actions/fetch-comment';
import { CREATE_COMMENT_SUCCESS } from '../actions/create-comment';
import { UPDATE_COMMENT_SUCCESS } from '../actions/update-comment';
import { DELETE_COMMENT_SUCCESS } from '../actions/delete-comment';
import { NEW_COMMENT } from '../actions/comment-socket';
import {
  INCREMENT_COMMENT_LIKE_COUNT_REQUEST,
  INCREMENT_COMMENT_LIKE_COUNT_SUCCESS,
  INCREMENT_COMMENT_LIKE_COUNT_FAILURE,
} from '../actions/increment-comment-like-count';
import { UPDATE_USER_SUCCESS } from '../actions/update-user';

const comment = (state, action) => {
  switch (action.type) {
    case INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
      if (state._id === action.payload._id) {
        return {
          ...state,
          isLiked: !state.isLiked,
          likeCount: state.likeCount + (state.isLiked ? -1 : 1),
          isLikeInProgress: true,
        };
      }
      return state;
    case INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
      if (state._id === action.payload._id) {
        return _.omit({ ...state, ...action.payload }, 'isLikeInProgress');
      }
      return state;
    case INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
      if (state._id === action.payload._id) {
        return _.omit(
          {
            ...state,
            isLiked: !state.isLiked,
            likeCount: state.likeCount + (state.isLiked ? -1 : 1),
          },
          'isLikeInProgress'
        );
      }
      return state;
    case UPDATE_USER_SUCCESS:
      if (state.owner._id === action.payload.id) {
        return { ...state, owner: action.payload };
      }
      return state;
    default:
      return state;
  }
};

const commentList = (state = [], { type, payload = {} } = {}) => {
  switch (type) {
    case FETCH_COMMENTS_SUCCESS:
      return _([...state, ...payload.comments]).unionBy('_id').sortBy('createdDate').value();
    case CREATE_COMMENT_SUCCESS:
    case UPDATE_COMMENT_SUCCESS:
    case NEW_COMMENT:
      return _([payload]).unionBy(state, '_id').sortBy('createdDate').value();
    case FETCH_COMMENT_SUCCESS:
      return _([payload.comment]).unionBy(state, '_id').sortBy('createdDate').value();
    case DELETE_COMMENT_SUCCESS:
      return state.filter(comment => comment._id !== payload._id);
    case INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
      return state.map(current => comment(current, { type, payload }));
    case INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
      return state.map(current => comment(current, { type, payload }));
    case INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
      return state.map(current => comment(current, { type, payload }));
    case UPDATE_USER_SUCCESS:
      return state.map(current => comment(current, { type, payload }));
    default:
      return state;
  }
};

export default function commentsReducer(state = {}, action) {
  const { type, payload = {} } = action;
  const { postId } = payload;

  switch (type) {
    case FETCH_COMMENTS_REQUEST:
      return {
        [postId]: state[postId],
      };
    case FETCH_COMMENTS_SUCCESS:
    case FETCH_COMMENT_SUCCESS:
    case CREATE_COMMENT_SUCCESS:
    case UPDATE_COMMENT_SUCCESS:
    case NEW_COMMENT:
    case DELETE_COMMENT_SUCCESS:
    case INCREMENT_COMMENT_LIKE_COUNT_REQUEST:
    case INCREMENT_COMMENT_LIKE_COUNT_SUCCESS:
    case INCREMENT_COMMENT_LIKE_COUNT_FAILURE:
      return {
        [postId]: commentList(state[postId], action),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/comments.js